module.exports = __webpack_public_path__ + "img/qus.bc5a4f11.png";